export default "__VITE_ASSET__B70Cep76__"